import { takeLatest, put, call } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import {
  SET_NEW_PASSWORD,
  SET_NEW_PASSWORD_FAIL,
  SET_NEW_PASSWORD_SUCCESS,
  SetNewPasswordActionType
} from '../redux/authReducer'

function* UpdatePasswordFlow(action: SetNewPasswordActionType): Generator<any, void, any> {
  try {
    yield call(apiCall, {
      endpoint: '/tutors/tutors/update_password',
      method: 'POST',
      params: { secure_id: action.payload.secureId, password: action.payload.password }
    })
    yield put(SET_NEW_PASSWORD_SUCCESS())
    window.location.href = '/'
  } catch (error) {
    yield put(SET_NEW_PASSWORD_FAIL())
    console.log(error)
  }
}

export default function* UpdatePasswordSaga(): Generator<any, void, any> {
  yield takeLatest([SET_NEW_PASSWORD], UpdatePasswordFlow)
}
